<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="stylus" scoped>
@import './common/styl/variable.styl'
</style>
<style>
  html,body,#app,.container {
    height: 100%
  }
</style>



// WEBPACK FOOTER //
// src/App.vue